module.exports = __webpack_public_path__ + "static/media/firefox.13f2caa4.png";